import { pb } from './pb';

export async function fetchProductsByCategory(categoryId){
  const filter = categoryId
    ? `(category='${categoryId}' || extra_categories.id ?= '${categoryId}') && published=true`
    : 'published=true';
  const list = await pb.collection('products').getFullList({ filter, sort: 'order,title', expand: 'category,extra_categories' });
  return list;
}

export async function fetchProductsByCategories(categoryIds){
  if(!Array.isArray(categoryIds) || !categoryIds.length){
    return fetchProductsByCategory(null);
  }
  const safeIds = categoryIds.filter(Boolean);
  if(!safeIds.length){
    return fetchProductsByCategory(null);
  }
  const orParts = safeIds.map(id => `(category='${id}' || extra_categories.id ?= '${id}')`);
  const filter = `(${orParts.join(' || ')}) && published=true`;
  const list = await pb.collection('products').getFullList({ filter, sort: 'order,title', expand: 'category,extra_categories' });
  return list;
}

export async function getProductBySlug(slug){
  if(!slug) throw new Error('Slug manquant');
  const res = await pb.collection('products').getList(1, 1, {
    filter: `slug="${slug}" && published=true`,
    sort: 'order,title',
    expand: 'category,extra_categories',
  });
  if(!res.items.length) throw new Error('Produit introuvable');
  return res.items[0];
}

export async function fetchProductsAdmin(page = 1, perPage = 20, search = ''){
  const filter = search ? `title ~ "%${search}%"` : '';
  return pb.collection('products').getList(page, perPage, {
    filter,
    sort: 'category,order,title',
    expand: 'category,extra_categories',
  });
}

export async function createProduct(data){
  return pb.collection('products').create(data);
}

export async function updateProduct(id, data){
  return pb.collection('products').update(id, data);
}

export async function deleteProduct(id){
  return pb.collection('products').delete(id);
}
